
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sarwa-insurance",
      function () {
        return require("private-next-pages/sarwa-insurance/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sarwa-insurance"])
      });
    }
  